import dayjs from 'dayjs';
import cloneDeep from 'lodash/cloneDeep';

import type { Recipient } from '@webapp/account/src/resources/smsing/recipient';

import { AlignSetting, getColor } from '@webapp/common/lib/ui';

export enum SmsType {
    MAIN = 1,
    RECIP_ADD = 2,
    NOTIFY = 3,
}

export const SMS_TYPE_LABEL = {
    [SmsType.NOTIFY]: 'Напоминание',
    [SmsType.MAIN]: 'Основной',
    [SmsType.RECIP_ADD]: 'Добавление получателей',
};

export enum SmsStatus {
    CREATED = 1,
    STATUS_WAITING_DELIVERY = 2,
    DELETED = 3,
    SENDING = 4,
    SENT = 5,
    CANCELED = 6,
    ERROR = 7,
}

export enum RecipientType {
    ALL = 'ALL',
    REPLY = 'REPLY',
    NO_REPLY = 'NO_REPLY',
}

export const SMS_STATUS_LABEL = {
    [SmsStatus.CREATED]: 'Создано',
    [SmsStatus.STATUS_WAITING_DELIVERY]: 'Ожидает отправки',
    [SmsStatus.DELETED]: 'Удалено',
    [SmsStatus.SENDING]: 'Отправляется',
    [SmsStatus.SENT]: 'Отправлено',
    [SmsStatus.CANCELED]: 'Отменено',
    [SmsStatus.ERROR]: 'Ошибка отправления',
};

export interface SmsGroup {
    id: number;
    name: string;
    phones: Array<{
        [key: string]: string;
    }>;
    hidden: boolean;
}

export const initialSmsGroup: Readonly<SmsGroup> = {
    id: 0,
    name: '',
    phones: [],
    hidden: true,
};

export enum SmsEditMode {
    TEMPLATE = 'template',
    HTML = 'html',
}

export interface SmsStat {
    all: number;
    answered: number;
    notAnswered: number;
}

export interface SmsParams {
    body: string;
    // template: string;
    headerColor: string;
    logoImage: string;
    logoImageName: string; // TODO purge
    logoImageHeight: number;
    excludeDuplicate: boolean;
    excludeDuplicatePeriod: number;
    excludeDuplicateWho: Array<string>;
    cyr2Lat: boolean;
    // duplicate: AnyObject;
    logoImageWidth: number;
    logoPos: AlignSetting;
    buttonText: string;
    buttonColor: string;
    editMode: SmsEditMode;
    disallowRefilling: boolean;
    expireDate?: dayjs.Dayjs;
    reminderListIds: Array<string>;
}

export interface Sms {
    id: number;
    filterActive: boolean;
    surveyId: number;
    who: RecipientType;
    smsType: SmsType;
    status: SmsStatus;
    recipients: Array<Recipient>;
    smsGroups: Array<SmsGroup>;
    stat: SmsStat; // TODO ?? move to state.stat
    title: string;
    fetch: boolean;
    template: string;
    duplicate: AnyObject;
    params: SmsParams;
    bindSms: boolean;
    senderSms: string;
    sendNow: boolean;
    sendDatetime: dayjs.Dayjs;
    replyAmount: number;
    smsAmount: number;
    tags?: Array<string>;
}

const template = `Пройдите опрос по ссылке - {survey_link}`;

export const initialSmsParams: Readonly<SmsParams> = {
    body: '',
    // template,
    headerColor: getColor('white'),
    logoImage: null,
    logoImageName: null,
    logoImageHeight: 0,
    logoImageWidth: 0,
    logoPos: AlignSetting.LEFT,
    excludeDuplicate: false,
    cyr2Lat: false,
    excludeDuplicateWho: ['ALL_NO_DELETE'],
    excludeDuplicatePeriod: 1,
    buttonText: 'Пройти опрос',
    buttonColor: getColor('blue'),
    editMode: SmsEditMode.TEMPLATE,
    disallowRefilling: true,
    reminderListIds: [],
};

export const initialSms: Readonly<Sms> = {
    duplicate: { ALL_NO_DELETE: 0, REPLY: 0, SEND_NO_REPLY: 0, total: 0 },
    surveyId: 0,
    filterActive: false,
    template,
    fetch: true,
    smsType: SmsType.MAIN,
    status: SmsStatus.CREATED,
    who: RecipientType.NO_REPLY,
    id: 0,
    recipients: [],
    smsGroups: [],
    stat: {
        all: 0,
        answered: 0,
        notAnswered: 0,
    },
    title: 'Новая рассылка',
    params: cloneDeep(initialSmsParams),
    bindSms: true,
    senderSms: '',
    sendNow: true,
    sendDatetime: dayjs(),
    replyAmount: 0,
    smsAmount: 0,
};
